<template>
  <hb-basic-page
    :back-button="{ show: true, fallback: 'tenant_surveys' }"
    :elevate-app-bar-on-scroll="false"
    :loading="loading"
    :subtle-loading="subtleLoading"
    app-bar-color="transparent"
    name="survey-created-view"
  >

    <v-col v-if="!loading" class="grey lighten-4 mt-n16 pt-10 mb-6 pb-10" cols="12">
      <v-row no-gutters>
        <NoContentView :description="$t('surveys.now_just_share_survey')"
                       :description-extra="$t('surveys.sharing_options_can_be_seen')"
                       :function-button="true"
                       :function-button-text="$t('surveys.back_to_surveys')"
                       :prop-function="backToSurveys"
                       :reload-button="false"
                       :title="$t('surveys.survey_type_created.' + survey.surveyTemplate.type)"
                       function-button-icon="mdi mdi-arrow-left"
                       title-image="img/undraw_completing_re_i7ap.svg"/>
      </v-row>
    </v-col>
    <v-col v-if="!loading" class="mt-n16" cols="12" lg="8" md="10" offset-lg="2" offset-md="1" offset-xl="3" xl="6">
      <v-row>
        <v-col cols="12">
          <share-survey-card :survey="survey" :teams="teams" elevation="2" @reload-teams="reloadTeams"/>
        </v-col>
        <survey-interpretation-tasks-card :loading="loading" :survey="survey" elevation="2"
                                          :automatically-create-tasks="true"/>
      </v-row>
    </v-col>

  </hb-basic-page>
</template>

<script>
import NoContentView from "@/components/NoContentView"
import surveyApi from "@/api/survey";
import teamApi from "@/api/team";
import ShareSurveyCard from "@/components/Tenant/ShareSurveyCard";
import SurveyInterpretationTasksCard from "@/components/Tenant/SingleSurvey/SurveyInterpretationTasksCard";

export default {
  name: 'SurveyCreatedView',
  components: {SurveyInterpretationTasksCard, ShareSurveyCard, NoContentView},
  props: ['id'],
  data() {
    return {
      loading: true,
      subtleLoading: false,
      teams: [],
      survey: {},
    };
  },
  methods: {
    backToSurveys() {
      this.$router.go(-1);
    },
    async reloadSurvey() {
      try {
        const response = await surveyApi.getSurvey(this.id);
        if (response) {
          this.survey = response;
        }
      } catch (e) {
        this.$handleApiError(e, this.$t('surveys.errors.error_loading_survey'));
      }
    },
    async reloadTeams() {
      try {
        const response = await teamApi.getTeams();
        if (response) {
          this.teams = response;
        }
      } catch (e) {
        this.$handleApiError(e, this.$t('surveys.errors.create_error'));
      }
    }
  },
  async mounted() {
    if (!this.$hasMatchingTenantRoles(['tenant_admin'])) {
      this.$router.replace({name: 'access_denied'});
      return;
    }
    await this.reloadSurvey();
    await this.reloadTeams();
    this.$store.dispatch('reloadMenuCount');
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  border-bottom: 2px solid var(--v-primary-base) !important;
}
</style>

<style lang="scss">
</style>
